import Styled from 'styled-components'

export default Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  top: 0;
  background: ${props => props.theme.colors.white};
  height: 100%;
  width: 26rem;
  box-shadow: -0.25rem 0 1rem 0 rgba(51, 51, 51, 0.1);
  border-top: 1px solid ${props => props.theme.colors.gray.shade50};
  ${props => props.anchor}: -26rem;
  z-index: 10;

  ${props => props.isOpen && `
    ${props.anchor}: 0;
  `}
`



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js